/**
 * Employee role options shared by any dropdown that lets a user pick
 * Member/Manager/Admin (Add Employee, Onboarding, Employee List edit form).
 */
export const ROLE_OPTIONS = [
  { label: 'Member', value: 'Member' },
  { label: 'Manager', value: 'Manager' },
  { label: 'Admin', value: 'Admin' },
];
